import { Injectable } from '@angular/core';
import { ExportContext, ExportFileFormat, ExportRange, ExportService, ExportTaskProcessor } from 'app/layout/export-overlay';
import { OrderAttributes, OrderWarehouseAttributes } from '@albatrosdeveloper/ave-models-package';
import { takeUntil } from 'rxjs';
import get from 'lodash-es/get';
import ceil from 'lodash-es/ceil';
import { OrderCustomerService } from '../../../reports/historic/order-customer/order-customer.service';
import { LOCALIZED_PROPERTIES, ORDER_EXPORT_ID, ORDER_TITLE } from './order.constants';
import { OrdersListService } from '../../order-list-components/order-list.service';

@Injectable()
export class OrderDeliveryCustomerExport {
  constructor(
    private exportService: ExportService,
    private orderCustomer: OrderCustomerService,
    private ordersListService: OrdersListService,
  ) {}

  private transformItem(item: OrderAttributes, detail: any) {
    const warehouse = this.getFirstWarehouse(item); // Obtiene el primer almacén

    return {
      serial: get(item, 'serial', ''),
      salesOffice: get(item, 'salesOffice.name', ''),
      route: get(item, 'subRoute.name', ''),
      shipTo: get(item, 'shipTo.externalKeys.code', ''),
      address: get(item, 'address.address', ''),
      paymentCondition: get(item, 'paymentCondition.externalKeys.code', ''),
      expeditionCondition: get(item, 'expeditionCondition.code', ''),
      materialCode: get(detail, 'material.code', ''),
      materialDescription: get(detail, 'material.name', ''),
      warehouse: warehouse?.code || '',
      warehouseName: warehouse?.name || '',
      soldUnitOfMeasure: get(detail, 'soldUnitOfMeasure.code', ''),
      soldQuantity: get(detail, 'soldQuantity', ''),
      confirmedErp: '', //CNT CONFIRMADA
      unitPrice: ExportTaskProcessor.types.number(get(detail, 'unitPrice', '??')),
      note: get(item, 'note', ''),
      deliveryQuantity: '', //CNT ENTREGADA
      deliveryNumber: '' //NRO ENTREGA
    };
  }


  private getFirstWarehouse(item: OrderAttributes): { code: string, name: string } | null {
    const warehouses = get(item, 'warehouses', []);
    if (!Array.isArray(warehouses) || warehouses.length === 0) return null;
    
    return {
      code: get(warehouses[0], 'externalKeys.code', ''),
      name: get(warehouses[0], 'name', '')
    };
  }
  
  private capitalizeFirstLetter(text: string): string {
    if (!text) return '';
    return text[0].toUpperCase() + text.substring(1).toLowerCase();
  }
  
  export(format: ExportFileFormat, range: ExportRange, totalItems: number, pageSize: number, pageIndex: number, filterData: any) {
    const totalPages = ceil(totalItems / pageSize) + 1;
    this.exportService.task({
      id: ORDER_EXPORT_ID,
      title: this.capitalizeFirstLetter(ORDER_TITLE),
      format: format,
      iterations: range === ExportRange.AllPages ? totalPages : 1,
      start: (ctx: ExportContext) => {
        ctx.processor.localizeItemProperties(ORDER_TITLE, LOCALIZED_PROPERTIES);
      },
      next: (ctx: ExportContext) => {
        const currentPage = range === ExportRange.AllPages ? ctx.iteration : pageIndex;
        let options = { 
          currentPage: currentPage,
          limitPerPage: pageSize,
        }
        
        const send = {
          type: filterData.type,
          creationDateTime: filterData.creationDateTime,
          office: filterData.office,
          route: filterData.route
        }

        this.ordersListService.findAllDownloadWithCount(
          options,
          send
        ).pipe(takeUntil(ctx.stopped)).subscribe((response) => {
          get(response, 'data.data', []).map((item) => { //Este solo descarga en excel
            const details = get(item, 'detail', []);
    
            if (details.length) {
              details.forEach((detail: any) => {
                ctx.processor.addToSection(ORDER_TITLE, this.transformItem(item, detail));
              });
            } else {
              ctx.processor.addToSection(ORDER_TITLE, this.transformItem(item, {}));
            }
          });
          ctx.next();
        });
      },
    }).start();
  }

  canStartTask() {
    if (this.exportService.taskIsActive(ORDER_EXPORT_ID)) {
      this.exportService.setVisible(true);
      return false;
    }
    return true;
  }
}
